"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormControl, FormMessage } from "@/components/ui/form";
import { Loader } from "lucide-react";
const locations = ["Southern Africa", "DR Congo", "Zambia", "Botswana", "Namibia", "Mozambique", "Madagascar"];
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center p-8 text-center border border-dashed border-border rounded-lg bg-muted/20">
        <p className="text-lg font-medium text-primary mb-4">{successMessage}</p>
        <Button onClick={resetForm} variant="outline">
          Send Another Message
        </Button>
      </div>;
  }
  const inputClassName = "border-dashed border-muted-foreground/50 bg-transparent rounded-sm focus-visible:ring-1 focus-visible:ring-primary focus-visible:border-primary placeholder:text-muted-foreground/70 uppercase text-xs tracking-wider py-6";
  return <Form onSubmit={handleSubmit} className="space-y-4">
      <FormField control={control} name="name" rules={{
      required: "Name & Surname is required"
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input placeholder="NAME & SURNAME" className={inputClassName} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="company" render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input placeholder="COMPANY" className={inputClassName} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="email" rules={{
      required: "Email Address is required",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email address"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input type="email" placeholder="EMAIL ADDRESS" className={inputClassName} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="phone" render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input type="tel" placeholder="CONTACT NUMBER" className={inputClassName} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="country" render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input placeholder="COUNTRY" className={inputClassName} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="subject" render={({
      field
    }) => <FormItem>
            <FormControl>
              <Input placeholder="SUBJECT" className={inputClassName} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Message is required"
    }} render={({
      field
    }) => <FormItem>
            <FormControl>
              <Textarea placeholder="MESSAGE" className={`min-h-[200px] resize-none ${inputClassName}`} {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-3 text-sm text-destructive border border-destructive/20 rounded-md bg-destructive/10">
          {submitError}
        </div>}

      <div className="flex justify-end pt-2">
        <Button type="submit" variant="outline" disabled={isSubmitting} className="px-8 uppercase tracking-wider text-xs rounded-sm border-muted-foreground/50 hover:bg-muted">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Submitting...
            </> : "Submit"}
        </Button>
      </div>
    </Form>;
}
export default function ContactFormAndDetails() {
  return <section id="contact-form-details" className="bg-background ![padding:5px_0px_96px_0px]">
      <div className="page-container">
        <div className="grid grid-cols-1 gap-16 lg:gap-24 items-start">
          
          <div className="w-full mx-auto flex flex-col items-center">
            
            <FormProvider className="w-full max-w-4xl" formId="contact-enquiries-main" sectionName="Contact Form & Details" defaultValues={{
            name: "",
            company: "",
            email: "",
            phone: "",
            country: "",
            subject: "",
            message: ""
          }} submitText="Submit" successMessage="Thank you for your enquiry. We will get back to you shortly.">
              <ContactFormInner />
            </FormProvider>
          </div>

        </div>
      </div>
    </section>;
}